import { Grid, Typography, Box } from "@mui/material";


import skinscraperCabinet from "../../../static/images/distant_bass_suite/cabinet-skinscraper-8x10-600.webp"
import skinscraperCabinetLarge from "../../../static/images/distant_bass_suite/cabinet-skinscraper-8x10.webp"
import fleshweaverCabinet from "../../../static/images/distant_bass_suite/cabinet-fleshweaver-4x12-600.webp"
import fleshweaverCabinetLarge from "../../../static/images/distant_bass_suite/cabinet-fleshweaver-4x12.webp"

const cabinets = [
  { name: "Skinscraper 8x10", alt: "Black Skinscraper 8x10 bass cabinet", image: skinscraperCabinet, largeImage: skinscraperCabinetLarge, width: 323 },
  { name: "Fleshweaver 4x12", alt: "White Fleshweaver 4x12 bass cabinet", image: fleshweaverCabinet, largeImage: fleshweaverCabinetLarge, width: 558 },
]

const CabinetBanner = () => {
  const textColor = "#F9F5EE"
  return <>
    <Box sx={{ px: { xs: 3, md: 5 }, py: 5, background: "radial-gradient(circle, #3a3a3a 0%, #1a1a1a 100%)", justifyContent: "center", alignItems: "center", color: textColor }} >
      <Box sx={{ maxWidth: 1080, mx: "auto", mb: 6 }}>
        <Grid container spacing={4} justifyContent="center" alignItems="flex-end">
          {cabinets.map((cabinet) => (
            <Grid item xs={12} sm={6} key={cabinet.name}>
              <Box component="figure" sx={{ m: 0, textAlign: "center" }}>
                <Box sx={{ height: { xs: 340, sm: 380, md: 460 }, mb: 2 }}>
                  <img
                    src={cabinet.image}
                    srcSet={`${cabinet.image} 1x, ${cabinet.largeImage} 2x`}
                    width={cabinet.width}
                    height={600}
                    alt={cabinet.alt}
                    loading="lazy"
                    decoding="async"
                    style={{ display: "block", width: "100%", height: "100%", objectFit: "contain" }}
                  />
                </Box>
                <Typography component="figcaption" variant="h6">{cabinet.name}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Grid container justifyContent={"center"} sx={{}}>
        <Grid item xs={12} md={6} lg={6} sx={{}}>
          <Typography sx={{ textAlign: "center", mb: 3, }} variant="h3">Cabinets and IRs</Typography>
          <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">The two purpose-built cabinets, Skinscraper 8x10 and Fleshweaver 4x12, are voiced to deliver a perfectly matched sound with their respective amplifiers. Each cabinet was recorded with seven high-end studio microphones, giving you a wide range of cabinet and microphone combinations.</Typography>
          <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">The new IR loader includes automatic alignment, ensuring that third-party IRs stay perfectly in phase with the built-in cabinets for effortless blending.</Typography>
        </Grid>
      </Grid>

    </Box >
  </ >
}

export default CabinetBanner;
